import { render, staticRenderFns } from "./UsersBatchManage.vue?vue&type=template&id=04e8bbe9&"
import script from "./UsersBatchManage.vue?vue&type=script&lang=js&"
export * from "./UsersBatchManage.vue?vue&type=script&lang=js&"
import style0 from "./UsersBatchManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports